import Alpine from 'alpinejs';

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

Alpine.magic('smoothscroll', () => (selector, { updateUrl = true } = {}) => {
  const targetEl = document.querySelector(selector);
  if (!targetEl) {
    console.warn(`$smoothscroll: no element found for selector "${selector}"`);
    return;
  }

  targetEl.scrollIntoView({
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });

  if (updateUrl) {
    history.pushState(null, '', selector);
  }
});
